import { render, staticRenderFns } from "./FurnitureLightingForm.vue?vue&type=template&id=7021e629&"
import script from "./FurnitureLightingForm.vue?vue&type=script&lang=js&"
export * from "./FurnitureLightingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7021e629')) {
      api.createRecord('7021e629', component.options)
    } else {
      api.reload('7021e629', component.options)
    }
    module.hot.accept("./FurnitureLightingForm.vue?vue&type=template&id=7021e629&", function () {
      api.rerender('7021e629', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/furniture_lighting/components/FurnitureLightingForm.vue"
export default component.exports